var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.7332 25.7067C21.4266 26.9733 19.9999 26.7733 18.6266 26.1733C17.1732 25.56 15.8399 25.5333 14.3066 26.1733C12.3866 27 11.3732 26.76 10.2266 25.7067C3.71989 19 4.67989 8.78666 12.0666 8.41332C13.8666 8.50666 15.1199 9.39999 16.1732 9.47999C17.7466 9.15999 19.2532 8.23999 20.9332 8.35999C22.9466 8.51999 24.4666 9.31999 25.4666 10.76C21.3066 13.2533 22.2932 18.7333 26.1066 20.2667C25.3466 22.2667 24.3599 24.2533 22.7199 25.72L22.7332 25.7067ZM16.0399 8.33332C15.8399 5.35999 18.2532 2.90666 21.0266 2.66666C21.4132 6.10666 17.9066 8.66666 16.0399 8.33332Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoApple);
export default __webpack_public_path__ + "static/media/logo_apple.e57b0bd04d4150be3ba3a7c649051f34.svg";
export { ForwardRef as ReactComponent };